document.addEventListener('DOMContentLoaded', () => {
  const personalizeBtn = document.querySelector('.zeptoApp-btn');
  const zeptoApp = document.querySelector('.product-personalizer');
  const productForm = document.querySelector('.shopify-product-form');
  let flag = true;

  try {
    if (!personalizeBtn) {
      console.warn('personalizeBtn element not found');
      return;
    }
    if (!productForm) {
      console.warn('productForm element not found');
      return;
    }

    if (zeptoApp) {
      personalizeBtn.classList.add('show');
      productForm.classList.add('hasPersonalize');

      personalizeBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (flag) {
          zeptoApp.classList.add('open');
          // personalizeBtn.classList.add('close')
          flag = false;
          // personalizeBtn.innerText = 'Remove'
          personalizeBtn.remove();
        } else {
          // personalizeBtn.classList.remove('open');
          zeptoApp.classList.remove('open');
          personalizeBtn.innerText = 'Personalize';
          flag = true;
        }
      });
    } else {
      personalizeBtn.classList.remove('show');
    }
  } catch (error) {
    console.error('Error initializing personalize button:', error);
  }
});
